/**
 * @author Gustavo Jimenez <soygus@gmail.com>
 */

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import "./fonts/GothamMedium.otf";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";

const queryParams = new URLSearchParams(window.location.search);
const lang = queryParams.get("lang");
const img = queryParams.get("img");
var lng = "en";
if (lang === "es" || lang === "en" || lang === "it" || lang === "fr") {
  lng = lang;
}

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  debug: false,
  lng: lng,
  resources: {
    en,
    es,
    fr,
    it,
  },
  react: {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    useSuspense: false,
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App img={img} />
  </React.StrictMode>
);
